import RouteContainer from 'components/RouteContainer';
import { PATHS } from 'constants/paths';
import React, { lazy } from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

const Home = lazy(() => import('./pages/Home'));
const WgWellSingleSchematic = lazy(() => import('./pages/WellGuardian/WellSingleSchematic'));
const WgWellSingleOverview = lazy(() => import('./pages/WellGuardian/WellSingleOverview'));
const WgWellCharts = lazy(() => import('./pages/WellGuardian/WellCharts'));
const WgWellReviews = lazy(() => import('./pages/WellGuardian/wellReviews'));
const WgWellBehaviour = lazy(() => import('./pages/WellGuardian/WellBehaviour'));
const WgWelldgshse = lazy(() => import('./pages/WellGuardian/Dgshse'));
const WgWellResource = lazy(() => import('./pages/WellGuardian/WellResources'));
const WgSubscription = lazy(() => import('./pages/WellGuardian/AlertsSubscription'));
const WgDerogations = lazy(() => import('./pages/WellGuardian/Derogations'));
const WgSynergiCases = lazy(() => import('./pages/WellGuardian/SynergiCases'));
const WgKeyLinks = lazy(() => import('./pages/WellGuardian/KeyLinks'));
const WgSingleWellAlerts = lazy(() => import('./pages/WellGuardian/WellAlerts/SingleWellAlerts'));
const WgMultipleWellsAlerts = lazy(
  () => import('./pages/WellGuardian/WellAlerts/MultipleWellsAlerts'),
);
const WgAllWells = lazy(() => import('./pages/WellGuardian/AllWells'));
const WgWIRInterventions = lazy(() => import('./pages/WellGuardian/WIR/WIRInterventions'));
const WgWIRCreation = lazy(() => import('./pages/WellGuardian/WIR/WIRCreation'));

const AppRoutes: React.FC = () => {
  const browserDetail = navigator.userAgent;

  const isMobile =
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(browserDetail) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(browserDetail);

  return (
    <RouterRoutes>
      <Route
        path={PATHS.HOME}
        element={
          <RouteContainer isMobile={isMobile} withMobileWellSelect={false}>
            <Home />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN}
        element={<Navigate to={PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME} replace />}
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME}
        element={
          <RouteContainer>
            <WgAllWells />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_INTERVENTIONS}
        element={
          <RouteContainer>
            <WgWIRInterventions />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_SINGLE_OVERVIEW}
        element={
          <RouteContainer>
            <WgWellSingleOverview />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_WELL_REVIEWS}
        element={
          <RouteContainer>
            <WgWellReviews />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_SINGLE_CHARTS}
        element={
          <RouteContainer>
            <WgWellCharts />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_SINGLE_SCHEMATIC}
        element={
          <RouteContainer>
            <WgWellSingleSchematic />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_BEHAVIOUR}
        element={
          <RouteContainer>
            <WgWellBehaviour />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_INTEGRITY_DETAILS}
        element={
          <RouteContainer>
            <WgWelldgshse />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WELL_RESOURCES}
        element={
          <RouteContainer>
            <WgWellResource />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_SINGLE_WELL_ALERTS}
        element={
          <RouteContainer>
            <WgSingleWellAlerts />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_MULTIPLE_WELLS_ALERTS}
        element={
          <RouteContainer>
            <WgMultipleWellsAlerts />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_ALERTS_SUBSCRIPTION}
        element={
          <RouteContainer>
            <WgSubscription />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_DEROGATIONS}
        element={
          <RouteContainer>
            <WgDerogations />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_SYNERGI_CASES}
        element={
          <RouteContainer>
            <WgSynergiCases />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_KEY_LINK}
        element={
          <RouteContainer>
            <WgKeyLinks />
          </RouteContainer>
        }
      />
      <Route
        path={PATHS.WELL_GUARDIAN_WIR_CREATION}
        element={
          <RouteContainer>
            <WgWIRCreation />
          </RouteContainer>
        }
      />
    </RouterRoutes>
  );
};
export default AppRoutes;
